import defaultValues from "config:./defaultValues";

export const getAnalyticsEventId = (() => {
  const dedupeServices: { [key: string]: string[] } =
    defaultValues.dedupeServices || {};

  const eventIds = new Map<string, [string, Set<string>]>();
  window.eventMap = eventIds;

  return (eventName: string, service: string) => {
    if (!dedupeServices[eventName]) {
      return;
    }

    const eventIdAndSvcs = eventIds.get(eventName);

    // If there is already an ID for this event/service, then it has not cleared out for some reason
    // but we don't want to re-use an ID for a different event, so just reset it and get a new ID
    if (
      eventIdAndSvcs === undefined ||
      (eventIdAndSvcs && eventIdAndSvcs[1].has(service))
    ) {
      const idToReturn = window.crypto.randomUUID();
      eventIds.set(eventName, [idToReturn, new Set([service])]);
      return idToReturn;
    } else {
      eventIdAndSvcs[1].add(service);
    }

    const id = eventIdAndSvcs[0];

    if (dedupeServices[eventName].every((svc) => eventIdAndSvcs[1].has(svc))) {
      eventIds.delete(eventName);
    }

    return id;
  };
})();
